import React from 'react';

export const UserCreation = (props: { creation: React.ReactNode; }) => {
    return (
        <div className={'user-item__info'}>
            Creation date: {props.creation}
        </div>
    )
}
